import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import { team } from './reducers-team';
import { draft, draftsLoading } from './reducers-draft';
import { user } from './reducers-user';

export default combineReducers({
    routing: routerReducer,
    form: formReducer,
    team,
    draft,
    draftsLoading,
    user,
})



// WEBPACK FOOTER //
// ./src/reducers/reducers-index.js